import { FlexBox, JoonUIColor, SPACING, Typography } from "@joonapp/web-shared"

import useCoachingProfile from "../../hooks/useCoachingProfile"
import { useUserQuery } from "../../networking/user/queries"

const PersonalInformation = () => {
  const { data: user } = useUserQuery()
  const coachProfile = useCoachingProfile()

  return (
    <FlexBox direction="column" wrap={false} gap={SPACING.space4}>
      <Typography variant="h3">Personal Information</Typography>
      <FlexBox
        justify="space-between"
        align="center"
        gap={SPACING.space2}
        wrap={false}
        style={{
          padding: SPACING.space4,
          border: `1px solid ${JoonUIColor.border.default}`,
          borderRadius: SPACING.space2,
          background: JoonUIColor.background.primaryNeutral,
        }}
      >
        <FlexBox
          gap={SPACING.space3}
          direction="row"
          justify="space-between"
          wrap={false}
        >
          <FlexBox direction="column">
            <Typography variant="bodyBold" textAlign="left">
              First name
            </Typography>
            <Typography variant="body" textAlign="left">
              {user?.name || "-"}
            </Typography>
          </FlexBox>
          <FlexBox direction="column">
            <Typography variant="bodyBold" textAlign="left">
              Last name
            </Typography>
            <Typography variant="body" textAlign="left">
              {user?.last_name || "-"}
            </Typography>
          </FlexBox>
          <FlexBox direction="column">
            <Typography variant="bodyBold" textAlign="left">
              Name your clients call you
            </Typography>

            <Typography variant="body" textAlign="left">
              {coachProfile?.nickname || "-"}
            </Typography>
          </FlexBox>
        </FlexBox>
      </FlexBox>
      <Typography variant="bodySmall">
        Please reach out to Brad to update any profile information.
      </Typography>
    </FlexBox>
  )
}

export default PersonalInformation
